import ChangeMethodCore from 'components/RwdBasket/Carts/CartLayout/SkuItem/ChangeMethod/ChangeMethodCore/ChangeMethodCore';

export default ChangeMethodCore;
